const statusMap = {
    'Uzun Far': {
        ttId: 'TT_ID0',
        tts: 'tts2',
    },
    'Kısa Far': {
        ttId: 'TT_ID0',
        tts: 'tts3',
    },
    'Klima': {
        ttId: 'TT_ID0',
        tts: 'tts1',
    },
    'Dönüş Sinyalleri': {
        ttId: 'TT_ID0',
        tts: 'tts4',
    },
    'Tehlike Uyarısı': {
        ttId: 'TT_ID0',
        tts: 'tts5',
    },
    'Engelliler için Anlam': {
        ttId: 'TT_ID0',
        tts: 'tts6',
    },
    'El Freni': {
        ttId: 'TT_ID0',
        tts: 'tts7',
    },
    'Fren Arızası': {
        ttId: 'TT_ID0',
        tts: 'tts8',
    },
    'Tavan Kapağı': {
        ttId: 'TT_ID0',
        tts: 'tts9',
    },
    'Yakıt Seviyesi': {
        ttId: 'TT_ID0',
        tts: 'tts10',
    },
    'Motor Soğutma Suyu Sıcaklığı': {
        ttId: 'TT_ID0',
        tts: 'tts11',
    },
    'Akıllı Şarj Durumu': {
        ttId: 'TT_ID0',
        tts: 'tts12',
    },
    'Motor Yağı': {
        ttId: 'TT_ID0',
        tts: 'tts13',
    },
    'Pozisyon Lambaları & Yan Lambalar': {
        ttId: 'TT_ID0',
        tts: 'tts14',
    },
    'Ön Sis Lambaları': {
        ttId: 'TT_ID0',
        tts: 'tts15',
    },
    'Arka Sis Lambaları': {
        ttId: 'TT_ID1',
        tts: 'tts1',
    },
    'Park Isıtma': {
        ttId: 'TT_ID1',
        tts: 'tts2',
    },
    'Motor / MI Göstergesi': {
        ttId: 'TT_ID1',
        tts: 'tts3',
    },
    'Servis & Bakım': {
        ttId: 'TT_ID1',
        tts: 'tts4',
    },
    'Şanzıman Sıvısı': {
        ttId: 'TT_ID1',
        tts: 'tts5',
    },
    'Şanzıman Hatası': {
        ttId: 'TT_ID1',
        tts: 'tts6',
    },
    'ABS Arızası': {
        ttId: 'TT_ID1',
        tts: 'tts7',
    },
    'Aşınmış Fren Balataları': {
        ttId: 'TT_ID1',
        tts: 'tts8',
    },
    'Ön Cam Yıkama Sıv.': {
        ttId: 'TT_ID1',
        tts: 'tts9',
    },
    'Lastik Arızası': {
        ttId: 'TT_ID1',
        tts: 'tts10',
    },
    'Arıza/Genel Arıza': {
        ttId: 'TT_ID1',
        tts: 'tts11',
    },
    'Motor Yağı Sıcaklığı': {
        ttId: 'TT_ID1',
        tts: 'tts12',
    },
    'Motor Yağı Seviyesi': {
        ttId: 'TT_ID1',
        tts: 'tts13',
    },
    'Motor Soğutma Suyu Seviyesi': {
        ttId: 'TT_ID1',
        tts: 'tts14',
    },
    'Direksiyon Sıvısı Seviyesi': {
        ttId: 'TT_ID1',
        tts: 'tts15',
    },
    'Direksiyon Arızası': {
        ttId: 'TT_ID2',
        tts: 'tts1',
    },
    'Yükseklik Kontrolü': {
        ttId: 'TT_ID2',
        tts: 'tts2',
    },
    'Retarder': {
        ttId: 'TT_ID2',
        tts: 'tts3',
    },
    'Motor Emisyon Sis. Arz.': {
        ttId: 'TT_ID2',
        tts: 'tts4',
    },
    'ESC Göstergesi': {
        ttId: 'TT_ID2',
        tts: 'tts5',
    },
    'Fren Lambası': {
        ttId: 'TT_ID2',
        tts: 'tts6',
    },
    '1. Körük': {
        ttId: 'TT_ID2',
        tts: 'tts7',
    },
    'Durma Talebi': {
        ttId: 'TT_ID2',
        tts: 'tts8',
    },
    'Çocuk Arabası İsteği': {
        ttId: 'TT_ID2',
        tts: 'tts9',
    },
    'Otobüs Durağı Freni': {
        ttId: 'TT_ID2',
        tts: 'tts10',
    },
    'Adblue Seviyesi': {
        ttId: 'TT_ID2',
        tts: 'tts11',
    },
    'Kaldırma': {
        ttId: 'TT_ID2',
        tts: 'tts12',
    },
    'Düşürme': {
        ttId: 'TT_ID2',
        tts: 'tts13',
    },
    'Alçaltma': {
        ttId: 'TT_ID2',
        tts: 'tts14',
    },
    'Motor Bölmesi Sıcaklığı': {
        ttId: 'TT_ID2',
        tts: 'tts15',
    },
    'Yardımcı Hava Basıncı': {
        ttId: 'TT_ID3',
        tts: 'tts1',
    },
    'Hava Filtresi': {
        ttId: 'TT_ID3',
        tts: 'tts2',
    },
    'Yakıt Filtresi Fark Basıncı': {
        ttId: 'TT_ID3',
        tts: 'tts3',
    },
    'Emniyet Kemeri': {
        ttId: 'TT_ID3',
        tts: 'tts4',
    },
    'EBS': {
        ttId: 'TT_ID3',
        tts: 'tts5',
    },
    'Şeritten Ayrılma Göstergesi': {
        ttId: 'TT_ID3',
        tts: 'tts6',
    },
    'Gelişmiş Acil Durum Fren Sis.': {
        ttId: 'TT_ID3',
        tts: 'tts7',
    },
    'ACC': {
        ttId: 'TT_ID3',
        tts: 'tts8',
    },
    'Römork Bağlandı': {
        ttId: 'TT_ID3',
        tts: 'tts9',
    },
    'ABS Trailer 1-2': {
        ttId: 'TT_ID3',
        tts: 'tts10',
    },
    'Airbag': {
        ttId: 'TT_ID3',
        tts: 'tts11',
    },
    'EBS Trailer 1-2': {
        ttId: 'TT_ID3',
        tts: 'tts12',
    },
    'Takograf Göstergesi': {
        ttId: 'TT_ID3',
        tts: 'tts13',
    },
    'ESC Göstergesi Kapalı': {
        ttId: 'TT_ID3',
        tts: 'tts14',
    },
    'Şeritten Ayrılma Gös. Kapalı': {
        ttId: 'TT_ID3',
        tts: 'tts15',
    },
    'Engine Emission Filter': {
        ttId: 'TT_ID4',
        tts: 'tts1',
    },
    'Elektrik Motoru Arızaları': {
        ttId: 'TT_ID4',
        tts: 'tts2',
    },
    'Adblue Tahrifat': {
        ttId: 'TT_ID4',
        tts: 'tts3',
    },
    'Multipleks Sistemi': {
        ttId: 'TT_ID4',
        tts: 'tts4',
    },
};

export default statusMap;
